/*back to top*/
jQuery(document).ready( function( $ ){
  "use strict";
  $('body').append('<div id="toTop" class="btn hidden-sm hidden-xs"><i class="fa fa-long-arrow-up"></i>Back to top </div>');
  $(window).scroll(function () {
    if ($(this).scrollTop() != 0) {
      $('#toTop').fadeIn();
    } else {
    }
  });
  $('#toTop').click(function(){
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });


  /** Search Panel **/
  $('.search-panel .dropdown-menu').find('a').on("click",function(e) {
    e.preventDefault();
    var param = $(this).attr("href").replace("#","");
    var concept = $(this).text();
    $('.search-panel span#search_concept').text(concept);
    $('.input-group #search_param').val(param);
  });

  /*Span menu click index3 */
  //Search
  $('a.search-header4').on('click', function () {
    $(this).removeAttr('href');
    var element = $(this).parent('span');
    if (element.hasClass('active')) {
      element.removeClass('active');
      element.find('span').removeClass('active');
      $('#search-home4').slideUp();
    }
    else {
      element.addClass('active');
      $('#search-home4').slideDown();
    }

  });
  $('a.search-header4').on('hover', function () {
    $(this).removeAttr('href');
    var element = $(this).parent('span');
    if (element.hasClass('active')) {
      element.removeClass('active');
      element.find('span').removeClass('active');
      $('#search-home4').slideUp();
    }
    else {
      element.addClass('active');
      $('#search-home4').slideDown();
    }

  });
  $('#close').on('click',function() {
    $('a.search-header4').parent('span').removeClass('active');
    $('#search-home4').slideUp();
  });
  $("#hl_head").on('click',function(){
    $("#hl_body").slideToggle('active');
  });
  $( ".top-header-v3 .btn-nav-icon" ).on('click',function() {
    $(".top-header-v3").toggleClass( "highlight" );
  });
  $( ".header-v1 .top-header .btn-nav-icon" ).on('click',function() {
    $(".top-header").toggleClass( "highlight" );
  });

  /*icon-nav*/
  var iconmenu = $('.btn-nav-icon'),
      vmenu    = $('.vmegamenu-contain');

  iconmenu.on('click', function(e){
    if ($(this).hasClass('active')){
      iconmenu.removeClass('active');
      vmenu.removeClass('active');
    }
    else {
      iconmenu.addClass('active');
      vmenu.addClass('active');
    }
    e.preventDefault();
  });

  /** Mega menu **/
  $(window).on("load resize ",function(){     
    "use strict";
    $("ul.engo-megamenu > li.dropdown").each(function () {
      var dropdown        = $(this).children(".dropdown-menu");
      var megamenu       = $("ul.engo-megamenu");
      $(dropdown).css("right", "auto");

      var dropdown_begin_mega = $(this).offset().left - megamenu.offset().left;
      if($(this).hasClass('aligned-fullwindown')) {
        var dropdown_begin = $(this).offset().left;
        $(dropdown).css({'left':-dropdown_begin,'width':$(window).width()});
      } else if($(this).hasClass('aligned-fullwidth')) {
        $(dropdown).css({'left':-dropdown_begin_mega,'width':$(megamenu).outerWidth()});
      } else if($(this).hasClass('aligned-right')) {
        var dropdown_end_right = ($(megamenu).offset().left + $(megamenu).outerWidth()) - ($(this).offset().left + $(this).outerWidth()) ;
        // console.log(dropdown_end_right);
        $(dropdown).css({'right':-dropdown_end_right});
      } else if($(this).hasClass('aligned-left')) {
        $(dropdown).css({'left':-dropdown_begin_mega});
      } else {
        var end_right     = ($(window).width() - (dropdown.offset().left + dropdown.outerWidth()));
        var end_right2    = ($(window).width() - (megamenu.offset().left + megamenu.outerWidth()));
        if(end_right2 > end_right) {
        }
      }
      $(this).hover(function () {
        $("ul.engo-megamenu > li").removeClass("active");
        $(this).addClass("active");

      },function () {
        $(this).removeClass("active");
      });

    });
    $('.header-nav .sub-menu.megamenu.dropdown-menu').show();
  });

  /** Vervical toggle menu **/
  $('.toggle-dropdown-menu ul li.item-toggle-dropdown').each(function(){
    if ($(this).find('.item-toggle-menu').length > 0) {
      $(this).append('<i class="closed toggle-button fa fa-plus"></i>');
    }
    $(this).find('.item-toggle-menu').slideUp('fast');
  });
  $( "body" ).on( "click", '.toggle-dropdown-menu ul li.item-toggle-dropdown .closed', function(){
    $(this).parent().find('.item-toggle-menu').first().slideDown('fast');
    $(this).removeClass('closed').removeClass('fa-plus').addClass('opened').addClass('fa-minus');
  });
  $( "body" ).on( "click", '.toggle-dropdown-menu ul li.item-toggle-dropdown .opened', function(){
    $(this).parent().find('.item-toggle-menu').first().slideUp('fast');
    $(this).removeClass('opened').removeClass('fa-minus').addClass('closed').addClass('fa-plus');
  });
});


/** Swiper slider **/
$( window ).load(function(){  
  var zoomConfig = {
    galleryActiveClass: "active"
  }
  var galleryTop_h1 = new Swiper('.gallery-top', {
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    spaceBetween: 10,
    loop:true,
    loopedSlides: 3, //looped slides should be the same
    onSlideChangeEnd: function (swiper) {
      var zoomImage = $('.gallery-top .swiper-slide:eq('+swiper.activeIndex+') .zoom_01');
      // Remove old instance od EZ
      $('.zoomContainer').remove();
      zoomImage.removeData('elevateZoom');
      zoomImage.data('zoom-image', zoomImage.data('zoom-image'));
      zoomImage.elevateZoom();
    }
  });
  var galleryThumbs_h1 = new Swiper('.gallery-thumbs', {
    spaceBetween: 10,
    slidesPerView: 3,
    touchRatio: 0.2,
    loop:true,
    loopedSlides: 3, //looped slides should be the same
    slideToClickedSlide: true,

    height: $('.product-viewer-left-img-big').height()
  });
  galleryTop_h1.params.control = galleryThumbs_h1;
  galleryThumbs_h1.params.control = galleryTop_h1;   
  console.log($('.product-viewer-left-img-big').height());
  $('.product-viewer-left-img-small').css('max-height',$('.product-viewer-left-img-big').height());
});
 



